import axios from 'axios';

import { KanzhongBackend } from 'constant/KanzhongBackend';
import { ServerError, createApiError } from 'stores/ApiClientError';

// --- リクエスト型 ---

/** ウォッチ追加（API7141） */
export type AddTicketWatchParams = {
  ticketId: string;
};

/** ウォッチ解除（API7142） */
export type RemoveTicketWatchParams = {
  ticketId: string;
};

// --- 共通 ---
const authHeader = () => ({
  headers: { 'X-Session-Id': localStorage.getItem('session-id') },
});

const handleError = (error: unknown): never => {
  if (axios.isAxiosError(error) && error.response) {
    const { status, data } = error.response;
    throw createApiError(status, data?.message || error.message);
  }
  throw new ServerError();
};

// --- API関数 ---

/**
 * ウォッチ追加API (API7141)
 * @param params.ticketId - チケットID（必須, 最大64文字。GLOBALのみ・冪等）
 */
export const addTicketWatch = async (params: AddTicketWatchParams): Promise<void> => {
  try {
    await axios.post(KanzhongBackend.ADD_TICKET_WATCH, params, authHeader());
  } catch (error) {
    handleError(error);
  }
};

/**
 * ウォッチ解除API (API7142)
 * @param params.ticketId - チケットID（必須, 最大64文字。冪等）
 */
export const removeTicketWatch = async (params: RemoveTicketWatchParams): Promise<void> => {
  try {
    await axios.post(KanzhongBackend.REMOVE_TICKET_WATCH, params, authHeader());
  } catch (error) {
    handleError(error);
  }
};
